<!-- Ported from account-v1/.../people/directory/directory.html.
     ft-sheet-tabs omitted (v2 passed an empty tabs array -> rendered nothing).
     ft-loading-animation / ft-infinite-scroll replaced (spinner is *ngIf-gated and
     not visible once data has loaded; infinite scroll via IntersectionObserver). -->
<section class="ft-master-section ft-people-directory-master">
    <section class="ft-section ft-panels-list-section">
        <div class="ft-container">
            <div class="search-form-container" *ngIf="hasPiiPermissions">
                <form class="ft-search-form" #guestsSearchForm="ngForm" novalidate (ngSubmit)="setCriteria(criteria)">
                    <div class="ft-search-field">
                        <input type="text"
                               name="criteria"
                               [(ngModel)]="criteria"
                               placeholder="{{'flipto.account.SearchGuests' | translate}}"
                               autocomplete="off">
                        <button type="submit"
                                class="ft-btn ft-btn-default"
                                [disabled]="guestsSearchForm.invalid">
                            <i class="ft-icn-search"></i>
                        </button>
                    </div>
                </form>
            </div>
            <div class="ft-section-header">
                <div class="ft-row">
                    <div class="ft-col-left">
                        <div class="ft-label">
                            <span *ngIf="searchText.length === 0">{{total | number}} people</span>
                            <span *ngIf="searchText.length > 0">
                                {{total | number}} results for "{{searchText}}"
                            </span>
                        </div>
                    </div>
                    <div class="ft-col-right">
                        <div class="ft-dropdown sort-toggle" ftClickClass toggleClass="active">
                            <a class="ft-btn ft-btn-outline-dark ft-dropdown-toggle">
                                {{filter.name}} <i class="ft-icn-caret-down"></i>
                            </a>
                            <ul class="ft-dropdown-menu">
                                <li *ngFor="let f of filters"
                                    (click)="changeFilter(f)">
                                    <a [class.active]="f.name === filter.name">
                                        {{f.name}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ft-panels-list">
                <div class="ft-row">
                    <div class="ft-col-50 people-list-column" *ngFor="let advocate of advocates">
                        <ft-guest-card type="directory"
                                        [guest]="advocate"
                                        (selected)="details($event)" />
                    </div>
                </div>
                <div #scrollSentinel></div>
                <div class="placeholder-panel"
                     *ngIf="!advocates.length && !isProcessingRequest">
                    There are no results given search criteria.
                </div>
            </div>
        </div>
    </section>
</section>
<!-- Child state people.directory.details renders here. Now a NATIVE Angular
     DetailsComponent (People M5b), so a plain Angular <ui-view> hosts it — the
     <ft-ui-view-wrapper> bridge was only needed while the child was AngularJS. -->
<ui-view />
